import { IonGrid, IonRow, IonCol, IonButton, IonLabel, IonSlides, IonSlide, IonInput, IonModal, IonItem } from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect, useRef} from 'react';

import { EnterPasswordModal } from '../../../zInternal_Features/merchant/components/Modal_EnterPassword';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

export function AddExpense_ProjectionModal (props) {


    let supplierNameRef = useRef();
    let supplierPhoneRef = useRef();
    let expenseDescriptionRef = useRef();
    let unitAmountRef = useRef();
    let quantityRef = useRef();
    //let totalAmountRef = useRef();
    let paymentTypeRef = useRef('cash');
    let selectedFileRef = useRef('');

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [projectedDate, setProjectedDate] = useState(null);

    let [showPasswordModal, setShowPasswordModal] = useState(false);
    //let [enteredPassword, setEnteredPassword] = useState('');
    //let [selectedFile, setSelectedFile] = useState(null);






    function addExpense(enteredPassword)
    {
        let totalExpenseAmount = +unitAmountRef.current.value * +quantityRef.current.value;

        /*
        let formData = new FormData();
        formData.append('Tracker', '74002B_P');
        formData.append('user', acctID);
        formData.append('xSupplierName', supplierNameRef.current.value);
        formData.append('xSupplierPhoneNumber', supplierPhoneRef.current.value);
        //formData.append('xSupplierEmailAddress', supplierEmailAddressRef.current.value);
        //formData.append('xSupplierAddressNumber', supplierAddressNumberRef.current.value);
        //formData.append('xSupplierStreetName', supplierStreetNameRef.current.value);
        //formData.append('xSupplierCity', supplierCityRef.current.value);
        //formData.append('xSupplierCityDistrict', supplierCityDistrictRef.current.value);
        //formData.append('xSupplierCountryRegion', supplierCountryRegionRef.current.value);
        //formData.append('xSupplierCountry', supplierCountryRef.current.value);
        //formData.append('xSupplierDigitalAddressID', employeeDigitalAddressIDRef.current.value)
        formData.append('xExpenseDescription', expenseDescriptionRef.current.value);
        formData.append('xExpenseUnitAmount', unitAmountRef.current.value);
        formData.append('xExpenseQuantity', quantityRef.current.value);
        formData.append('xExpenseTotalAmount', totalExpenseAmount);
        formData.append('xPaymentType', paymentTypeRef.current.value);
        formData.append('xSupportingDocumentation', selectedFileRef.current.value);
        formData.append('xEnterAdminPassword', enteredPassword);
        formData.append('xProjectedDate', projectedDate.toISOString().substr(0, 10));

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }

        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74002B_P',
                user: acctID,
                xSupplierName: supplierNameRef.current.value,
                xSupplierPhoneNumber: supplierPhoneRef.current.value,
                /*xSupplierEmailAddress: supplierEmailAddressRef.current.value,
                xSupplierAddressNumber: supplierAddressNumberRef.current.value,
                xSupplierStreetName: supplierStreetNameRef.current.value,
                xSupplierCity: supplierCityRef.current.value,
                xSupplierCityDistrict: supplierCityDistrictRef.current.value,
                xSupplierCountryRegion: supplierCountryRegionRef.current.value,
                xSupplierCountry: supplierCountryRef.current.value,
                xSupplierDigitalAddressID: employeeDigitalAddressIDRef.current.value,*/
                xExpenseDescription: expenseDescriptionRef.current.value,
                xExpenseUnitAmount: unitAmountRef.current.value,
                xExpenseQuantity: quantityRef.current.value,
                xExpenseTotalAmount: totalExpenseAmount,
                xPaymentType: paymentTypeRef.current.value,
                xSupportingDocumentation: selectedFileRef.current.value,
                xEnterAdminPassword: enteredPassword,
                xProjectedDate: projectedDate.toISOString().substr(0, 10),
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);

            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }


    function projectedDateHandler(e) { 
        
          setProjectedDate(new Date(e.target.value));  
      }

    function onSubmitPasswordHandler(enteredPassword)
    {
        alert('In onSubmitPasswordHandler');
        alert(enteredPassword);

        //setEnteredPassword(event);
        addExpense(enteredPassword);
    }

    function closeModalHandler() {

        props.closeModal(false);
    }

    return (

            <React.Fragment>
                {
                props.openModal == true ?
                (
                    <IonModal isOpen={ props.openModal }>
                    <IonSlides pager='true'>
                        <IonSlide>
                            <IonItem>
                                <IonLabel for="employeeRole">Payment Type </IonLabel>
                                {/*<select name="employeeRole" id='employeeRole' ref={(e) => handleCreateEmployeeCompanyRole(e) }>*/}
                                <select name="employeeRole" id='employeeRole' ref={paymentTypeRef }>
                                    <option value='cashr'>Cash</option>
                                    <option value='mobile_money'>Mobile Money</option>
                                </select>
                            </IonItem>
                            <IonItem>
                                <IonLabel for='projectedDate'>Projected ExpenseDate: </IonLabel>
                                <IonInput type='date' id='projectedDate' onIonChange={projectedDateHandler}></IonInput>
                            </IonItem>
                        </IonSlide>
                        <IonSlide>
                            <IonLabel>Supplier Name: </IonLabel>
                            <IonInput type='text' placeholder='Enter Supplier Name' ref={ supplierNameRef }></IonInput>
                        </IonSlide>
                        <IonSlide>
                            <IonLabel>Supplier Phone Number: </IonLabel>
                            <IonInput type='text' placeholder='Enter Supplier Phone Number' ref={ supplierPhoneRef }></IonInput>
                        </IonSlide>
                        {/*<IonSlide>
                            <IonItem>
                                <IonLabel>Supplier City District: </IonLabel>
                                <IonInput placeholder='Enter Digital Address' ref={ employeeDigitalAddressIDRef }></IonInput>
                            </IonItem>
                        </IonSlide>
                        <IonSlide>
                            <IonItem>
                                <IonLabel>Supplier Digital Address ID: </IonLabel>
                                <IonInput placeholder='Enter Digital Address' ref={ employeeDigitalAddressIDRef }></IonInput>
                            </IonItem>
                        </IonSlide>*/}
                        <IonSlide>
                            <IonLabel>Expense Description: </IonLabel>
                            <IonInput type='text' placeholder='Enter Description' ref={ expenseDescriptionRef }></IonInput>
                        </IonSlide>
                        <IonSlide>
                            <IonLabel>Unit Amount: </IonLabel>
                            <IonInput type='text' placeholder='Enter Unit Amount' ref={ unitAmountRef }></IonInput>
                        </IonSlide>
                        <IonSlide>
                            <IonLabel>Quantity: </IonLabel>
                            <IonInput type='number' placeholder='Enter Qty' ref={ quantityRef }></IonInput>
                        </IonSlide>
                        <IonSlide>
                            <IonLabel>Attachement </IonLabel>
                            <IonItem> 
                            <h1>Upload Supporting Documentation</h1>
                            <form id='fileUpload' enctype='multipart/form-data'>
                                {/*<input type='file' name='imageFile' accept="image/*" onChange={(e) => saveUploadedFile(e)}></input>*/}
                                <input type='file' name='imageFile' accept="image/*" ref={selectedFileRef}></input>

                                <label for='noAttachment'>No Attachment</label>
                                    {/*<input type='checkbox' id='noAttachment' value='noImage' onClick={(e) => saveUploadedFile(e)}></input>*/}
                                    <input type='checkbox' id='noAttachment' value='/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg' ref={selectedFileRef}></input>

                                {/*<input type="button" value="upload" onClick={uplodFile} ></input>*/}
                            </form>
                            </IonItem>

                            <IonButton onClick={() => setShowPasswordModal(true)}> Add Expense </IonButton>

                            <EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>      

                        </IonSlide>
                    </IonSlides>
                    <IonButton onClick={() => closeModalHandler(false)}>Cancel </IonButton>
                    </IonModal>) : null
                }
            </React.Fragment>

    )
}